import { render } from "./PracticeSms.vue?vue&type=template&id=e98d88ec"
import script from "./PracticeSms.vue?vue&type=script&lang=js"
export * from "./PracticeSms.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__